import { isTransferItem } from 'lib/checkout/checkoutUtils'
import { reselectShallowEqual } from 'lib/selector/selectorUtils'
import { createSelector } from 'reselect'

const getTransferItems = createSelector(
  (state: App.State) => state.checkout.cart.items,
  (items): Array<App.Checkout.TransferItem> => items.filter(isTransferItem),
  reselectShallowEqual,
)

export default getTransferItems
